import { render, staticRenderFns } from "./StarCloud.vue?vue&type=template&id=dac273aa&scoped=true&"
import script from "./StarCloud.vue?vue&type=script&lang=js&"
export * from "./StarCloud.vue?vue&type=script&lang=js&"
import style0 from "./StarCloud.vue?vue&type=style&index=0&id=dac273aa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac273aa",
  null
  
)

export default component.exports